import { LOAD_CANDIDATOS, LOAD_VOTOS } from './types'
import { request } from '../../../request'

function sortCandidatos(data) {
  return data.sort((a, b) => {
    if (a.total_votos < b.total_votos) {
      return 1
    }

    if (a.total_votos > b.total_votos) {
      return -1
    }

    const dateA = new Date(a.data_nascimento)
    const dateB = new Date(b.data_nascimento)
    if (dateA > dateB) {
      return 1
    }

    if (dateA < dateB) {
      return -1
    }

    return 0
  })
}

async function loadByKey(url) {
  try {
    const response = await request.get(`eleicoes-conselho/${url}`)
    return response.data
  } catch (error) {
    console.log(error)
    return []
  }
}

export const actions = {
  async loadCandidatos(store) {
    const data = await loadByKey('candidatos')

    const reducer = (acum, atual) => {
      return (acum += Number(atual.total_votos))
    }

    const candidatos = sortCandidatos(
      data.map(candidato => {
        return {
          ...candidato,
          total_votos: candidato.votos.reduce(reducer, 0)
        }
      })
    )

    store.commit(
      LOAD_CANDIDATOS,
      candidatos.map((candidato, index) => {
        return {
          ...candidato,
          posicao: index + 1
        }
      })
    )
  },
  async loadVotos(store) {
    const data = await loadByKey('votos')
    store.commit(LOAD_VOTOS, data)
  }
}

export const getters = {
  votosTotais(state) {
    const reducer = key => (acum, atual) => {
      return (acum += Number(atual[key]) || 0)
    }

    const total_nominais = state.votos.reduce(reducer('total_nominais'), 0)
    const total_brancos = state.votos.reduce(reducer('total_brancos'), 0)
    const total_nulos = state.votos.reduce(reducer('total_nulos'), 0)

    return {
      total_nominais,
      total_brancos,
      total_nulos,
      total_geral: total_nominais + total_brancos + total_nulos
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/eleicoes_conselho/actions.js